const Train = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path data-name="layer6" d="M50 57H14a1 1 0 0 1 0-2h36a1 1 0 0 1 0 2z" fill="#838383"></path>
    <path
      data-name="layer5"
      d="M10 63a1 1 0 0 1-.831-1.555l9.623-14.436a1 1 0 0 1 1.664 1.109l-9.624 14.436A1 1 0 0 1 10 63zm44 0a1 1 0 0 1-.833-.445l-9.061-13.59a1 1 0 1 1 1.664-1.109l9.061 13.59A1 1 0 0 1 54 63z"
      fill="#959595"
    ></path>
    <path data-name="layer1" d="M10 47a3 3 0 0 0 3 3h38a3 3 0 0 0 3-3V34H10z" fill={color}></path>
    <path data-name="layer4" fill={color} d="M11.919 13.997h40.162v20H11.919z"></path>
    <path data-name="layer1" d="M54 5a3 3 0 0 0-3-3H13a3 3 0 0 0-3 3v9h44z" fill={color}></path>
    <path
      data-name="opacity"
      fill="#fff"
      opacity=".4"
      d="M35.685 13.997l-20 20h12.63l20-20h-12.63z"
    ></path>
    <path data-name="layer3" d="M36 9h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2z" fill="#c1c1c1"></path>
    <circle data-name="layer2" cx="17.998" cy="41.997" r="3" fill="#ffffff"></circle>
    <circle data-name="layer2" cx="46" cy="41.997" r="3" fill="#ffffff"></circle>
    <path
      data-name="layer1"
      fill="#d2d2d2"
      d="M10 13.997h1.917v20H10zm42.081 0h1.917v20h-1.917z"
    ></path>
  </svg>
);

export default Train;
